import firebaseConfig from './firebase_config'
var defaultExport={}

//FireBase - //Since version 6.0.0 , config is fetched from firebase_config.js - for easier setup
defaultExport.firebaseConfig = {
  apiKey: "AIzaSyB0VrVxFnB2iYW-SgLS0Zbgfaq7kOVDeYA",
  authDomain: "mychurchdemo-c4153.firebaseapp.com",
  databaseURL: "https://mychurchdemo-c4153.firebaseio.com",
  projectId: "mychurchdemo-c4153",
  storageBucket: "gs://mychurchdemo-c4153.appspot.com",
  messagingSenderId: "536994826005",
  appId: "1:536994826005:web:9114560543b7cb2d"
};
//App setup
defaultExport.adminConfig={
  appName: "myCOR App",
        slogan: "Admin Panel.",
        design: {
            sidebarBg: "sidebar-3.jpg",
            dataActiveColor: "rose", // orange, purple, rose, red
            dataBackgroundColor: "black" // black, white
        },
        codeversion: "1.0",
        allowedUsers: null,
        fieldBoxName: "Fields",
        maxNumberOfTableHeaders: 5,
        prefixForJoin: [],
        methodOfInsertingNewObjects: "timestamp", //change here 
        urlSeparator: "+",
        fieldsTypes: {
            photo: ["photo", "image", "thumbnail", "icon", "shareImage"],
            dateTime: ["datetime", "start"],
            time: ["time"],
            maps: ["map", "latlng"],
            textarea: ["description"],
            html: ["content", "description", "info"],
            radio: ["radio"],
            checkbox: ["checkbox"],
            dropdowns: ["status", "dropdowns"],
            file: ["video"],
            rgbaColor: ["rgba"],
            hexColor: ["color"],
            relation: ["type"]
        },
        optionsForSelect: [{
            key: "dropdowns",
            options: ["new", "processing", "rejected", "completed"]
        }, {
            key: "checkbox",
            options: ["Skopje", "Belgrade", "New York"]
        }, {
            key: "status",
            options: ["just_created", "confirmed", "canceled"]
        }, {
            key: "radio",
            options: ["no", "maybe", "yes"]
        }
      ],
        optionsForRelation: [{
            key: "type",
            path: "/static/type",
            value: "name",
            display: "name",
            isValuePath: false,
            produceRelationKey: false,
            relationKey: "type_eventid",
            relationJoiner: "-"
        }],
        paging: {
            pageSize: 20,
            finite: !0,
            retainLastPage: !1
        }
}

//Navigation
defaultExport.navigation=[
  {
    link: "/",
    name: "Dashboard",
    schema: null,
    icon: "home",
    isIndex: !0,
    path: ""
}, {
    link: "fireadmin",
    path: "sermons",
    name: "Sermons",
    icon: "record_voice_over",
    tableFields: ["title","photo","description"]
}, {
    link: "fireadmin",
    path: "events",
    name: "Events",
    icon: "today",
    tableFields: ["title","photo","date"]
}, {
    link: "fireadmin",
    path: "bible",
    name: "Bible",
    icon: "import_contacts",
    tableFields: ["BibleURL"]
}, {
    link: "fireadmin",
    path: "news",
    name: "News",
    icon: "content_copy",
    tableFields: ["title","photo","date"]
}, {
    link: "fireadmin",
    path: "mySection",
    name: "My Section",
    icon: "transform",
    tableFields: ["title","description","type"],
//     subMenus : [{
//         link: "fireadmin",
//         path: "mySection/item/0",
//         name: "Image",
//         icon: "local_florist",
//         tableFields: ["title", "path", "description","date","type"]
//     }, {
//         link: "fireadmin",
//         path: "mySection/item/1",
//         name: "Video",
//         icon: "playlist_play",
//         tableFields: ["title", "path", "description","date","type"]
//     },{
//         link: "fireadmin",
//         path: "mySection/item/2",
//         name: "Pdf",
//         icon: "forum",
//         tableFields: ["title", "path", "description","date","type"]
//     }, {
//         link: "fireadmin",
//         path: "mySection/item/3",
//         name: "Folder",
//         icon: "insert_drive_file",
//         tableFields: ["title", "date", "item","type"],
//     },
//     {
//         link: "fireadmin",
//         path: "more/connect",
//         name: "Connect",
//         icon: "transform",
//         tableFields: ["image", "title", "heading"]
//     }, {
//         link: "fireadmin",
//         path: "more/tithing",
//         name: "Tithing",
//         icon: "local_florist",
//         tableFields: ["image", "title", "heading"]
//     }, {
//         link: "fireadmin",
//         path: "more/music",
//         name: "Music",
//         icon: "playlist_play",
//         tableFields: ["image", "title"]
//     }, {
//         link: "fireadmin",
//         path: "more/social",
//         name: "Social",
//         icon: "forum",
//         tableFields: ["image", "title"]
//     }
// ]
},
 {
    link: "push",
    path: "",
    name: "Push Notifications",
    icon: "notifications_active",
    tableFields: []
}
  ];

  //From v 5.1.0 we suggest remoteSetup due to security
  //
defaultExport.pushSettings={
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"onesignal", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AIzaSyCFUf7fspu61J9YsWE-2A-vI9of1ihtSiE", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"MDIyNzUzNTktMDI1YS00MGE3LWFlNTMtYTEyNjAzNmNmMDQy",
  "oneSignal_APP_KEY":"11ee1f8d-fa79-411e-9630-1e47168094fe",
  "included_segments":"Active Users", //Only for onesignal push
  "firebasePathToTokens":"/expoPushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":true, //Should we store the notification in firestore
}

defaultExport.filesSettings={
  "filesPath":"/TESTFILES/"
}

//flag to now which app we are using to configure Languages Style
defaultExport.appToConfig="fireadmin"

defaultExport.userDetails={

}

defaultExport.activeTranslation={
  "dynamic" : {
    "Dashboard" : "Dashboard",
    "Design" : "Design"
  },
  "static" : {
    "And_preview_you_app" : "And Preview Your App",
    "Just_scan_the_QR_code" : "Just Scan The QR Code"
  }
};

defaultExport.remoteSetup=false;
defaultExport.remotePath="admins/mobidonia";
defaultExport.allowSubDomainControl=true;
defaultExport.subDomainControlHolder="admins/";
defaultExport.saasappadmindata="appadmin_pointers/data/"
defaultExport.isAppCreator=false;
defaultExport.appEditPath=undefined;
defaultExport.isDemo=true; 
defaultExport.tinyMCEAPIKey="6pj2pzei8elldo831v5cdauvbl7z3yeqdo4vfddyok1v2yab"

export default defaultExport;


// WEBPACK FOOTER //
// ./src/config/app.js